var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9583 20.4583C24.1666 19.5833 22.6249 18.2916 22.6249 13.9999C22.6249 10.7916 20.3749 8.20825 17.2916 7.54159V6.66659C17.2916 5.95825 16.7083 5.33325 15.9999 5.33325C15.2499 5.33325 14.6666 5.95825 14.6666 6.66659V7.54159C11.5833 8.20825 9.33325 10.7916 9.33325 13.9999C9.33325 18.2916 7.79159 19.5833 6.99992 20.4583C6.74992 20.7083 6.62492 21.0416 6.66659 21.3333C6.66659 22.0416 7.16659 22.6666 7.99992 22.6666H23.9583C24.7916 22.6666 25.2916 22.0416 25.3333 21.3333C25.3333 21.0416 25.2083 20.7083 24.9583 20.4583ZM9.45825 20.6666C10.3333 19.5416 11.2916 17.5833 11.3333 14.0416C11.3333 14.0416 11.3333 14.0416 11.3333 13.9999C11.3333 11.4583 13.4166 9.33325 15.9999 9.33325C18.5416 9.33325 20.6666 11.4583 20.6666 13.9999C20.6666 14.0416 20.6249 14.0416 20.6249 14.0416C20.6666 17.5833 21.6249 19.5416 22.4999 20.6666H9.45825ZM15.9999 26.6666C17.4583 26.6666 18.6249 25.4999 18.6249 23.9999H13.3333C13.3333 25.4999 14.4999 26.6666 15.9999 26.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedNotification);
export default __webpack_public_path__ + "static/media/Selected Notification.53738cf921cee7884cd71bfcb03ec237.svg";
export { ForwardRef as ReactComponent };